import { useState } from 'react';
import Tabs from '@cloudscape-design/components/tabs';
import { HiddenCharactersTab, AboutTab } from '@components/index';

const InvisibleCharactersTool = () => {
  const [activeTabId, setActiveTabId] = useState('remove');

  return (
    <Tabs
      activeTabId={activeTabId}
      onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
      tabs={[
        {
          id: 'remove',
          label: 'Analyze text on invisible Characters',
          content: <HiddenCharactersTab />,
        },
        {
          id: 'about',
          label: 'About Analyze text on invisible Characters',
          content: <AboutTab />,
        },
      ]}
    />
  );
};

export default InvisibleCharactersTool;

